import React from 'react';
import { useUI } from '../../context/UIContext';
import { CloseIcon } from '../icons';

// Accessible toast (replaces the Bootstrap Alert). Reads the current notification from
// UIContext (which auto-dismisses after 3.5s). Grayscale — success/error differ only by
// the ARIA role (status vs alert), not colour, keeping the chrome monochrome.
export const Notification = () => {
    const { notification, dismissNotification } = useUI();
    if (!notification) return null;

    return (
        <div className="pointer-events-none fixed right-4 top-4 z-[70]">
            <div
                role={notification.variant === 'error' ? 'alert' : 'status'}
                className="pointer-events-auto flex items-center gap-3 border border-tone-200 bg-canvas px-4 py-3 text-caption text-ink shadow-lg"
            >
                <span>{notification.message}</span>
                <button type="button" onClick={dismissNotification} aria-label="Dismiss" className="text-tone-800 hover:text-black">
                    <CloseIcon size={16} />
                </button>
            </div>
        </div>
    );
};
